export function formatCardNumber(value: string, gaps: number[]): string {
  const cleaned = value.replace(/\D+/g, '');

  let result = '';
  for (let i = 0; i < cleaned.length; i++) {
    if (gaps.includes(i) && i !== 0) {
      result += ' ';
    }
    result += cleaned[i];
  }

  return result;
}

export function formatExpiry(value: string): string {
  // remove all non-digit characters
  const cleaned = value.replace(/\D+/g, '');
  if (!cleaned) return '';
  // format as MM/YY
  if (cleaned.length <= 2) {
    return cleaned;
  }
  return cleaned.slice(0, 2) + '/' + cleaned.slice(2, 4);
}

export function formatCVC(value: string): string {
  let cleaned = value.replace(/\D+/g, '');
  // limit length to 4 for AMEX (CVC can be 3 or 4 digits)
  if (cleaned.length > 4) {
    cleaned = cleaned.slice(0, 4);
  }
  return cleaned;
}

/** @deprecated Use formatCVC instead */
export const formatCVV = formatCVC;

export function buildUrl(url: string, paramObject: any = null) {
  const params =
    paramObject && paramObject !== undefined ? Object.keys(paramObject) : [];
  let baseUrl = url;
  for (let x = 0; x < params.length; x++) {
    do {
      baseUrl = baseUrl.replace(`:${params[x]}`, paramObject[params[x]]);
    } while (baseUrl.indexOf(`:${params[x]}`) !== -1);
  }
  return baseUrl;
}
